import { useRef, useEffect } from 'react'
import { useEvent } from '@fs/zion-frontend-friends'

export default function useScrollInputIntoView(): () => void {
  const cleanupRef = useRef<() => void>()
  useEffect(() => {
    return cleanupRef.current
  }, [])

  const scrollToInput = useEvent(() => {
    const scrollRequest = setTimeout(() => {
      const tagName = document.activeElement?.tagName.toLowerCase()

      if (tagName === 'input' || tagName === 'textarea') {
        // using `block: end` to fix alignment issues with inputs inside DialogOverlays on mobile (ZIONUIV13-149)
        // @ts-expect-error -- TODO fix strict issue: This was grandfathered from before we adopted strict mode in typescript.
        document.activeElement.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'auto' })

        cleanupRef.current?.()
        cleanupRef.current = undefined
      }
    }, 0)
    cleanupRef.current = () => clearTimeout(scrollRequest)
  })

  return scrollToInput
}
